import { useMemo } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Drawer, useMediaQuery } from '@mui/material';

// project import
import useMenuAction from "../../../hooks/menu/useMenuAction";
import useMenuData from "../../../hooks/menu/useMenuData";
import { DRAWER_WIDTH } from "../../../themes/config";
import DrawerContent from "./drawerContent/drawerContent";
import DrawerHeader from "./drawerHeader/drawerHeader";
import MiniDrawerStyled from "./miniDrawerStyled";

// ==============================|| MAIN LAYOUT - DRAWER ||============================== //

const MainDrawer = ({ window }) => {
	const theme = useTheme();
	const matchDownSM = useMediaQuery(theme.breakpoints.down('sm'));
	// responsive drawer container
	const container = window !== undefined ? () => window().document.body : undefined;
	const { drawerOpen } = useMenuData()
	const { setDrawerOpen } = useMenuAction()
	
	const drawerContent = useMemo(() => <DrawerContent/>, []);
	const drawerHeader = useMemo(() => <DrawerHeader drawerOpen={drawerOpen}/>, [drawerOpen]);
	return (
		<Box component="nav" sx={{ flexShrink: { md: 0 }, zIndex: 10 }} aria-label="mailbox folders">
			{!matchDownSM ? (
				<MiniDrawerStyled
					variant="permanent"
					open={drawerOpen}
					onClick={() => setDrawerOpen(!drawerOpen)}
				>
					{drawerHeader}
					{drawerContent}
				</MiniDrawerStyled>
			) : (
				<Drawer
					container={container}
					variant="temporary"
					open={drawerOpen}
					onClose={() => setDrawerOpen(!drawerOpen)}
					ModalProps={{ keepMounted: true }}
					sx={{
						display: { xs: 'block', lg: 'none' },
						'& .MuiDrawer-paper': {
							boxSizing: 'border-box',
							width: DRAWER_WIDTH,
							borderRight: `1px solid ${theme.palette.divider}`,
							boxShadow: 'inherit',
							// backgroundImage: `url(${bgSideBarImage})`,
							position: 'absolute',
							backgroundSize: 'cover',
							backgroundPosition: 'center center',
							'&:before': {
								position: 'absolute',
								width: '100%',
								height: '100%',
								content: '""',
								display: 'block',
							}
						}
					}}
					onClick={() => setDrawerOpen(!drawerOpen)}
				>
					{drawerHeader}
					{drawerContent}
				</Drawer>
			)}
		</Box>
	);
};

export default MainDrawer;
